<template>
  <div class="final-table-item">
    <div class="final-table-item__title">{{ item.title }}</div>
    <div class="final-table-item__value">{{ item.value }}</div>
    <div class="final-table-item__address" v-html="item.address"></div>
  </div>
</template>

<script>
export default {
  name: "ScheduleFinalTable",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.final-table-item {
  text-transform: uppercase;
  font-weight: bold;
  width: 50%;
  border-bottom: 3px solid colors(palette-2);
  padding: 13px 3%;

  &:nth-child(2n + 1) {
    border-right: 3px solid colors(palette-2);
  }

  &__title {
    color: colors(text-2);
    font-size: 22px;
  }
  &__value {
    color: colors(text-4);
    font-size: 36px;
  }

  @include breakpoint("md-only") {
    padding: 13px 2%;
  }

  @include breakpoint("sm-and-down") {
    width: 100%;
    &:nth-child(2n + 1) {
      border-right: none;
    }
  }
}
</style>
